export class SetPersonalDetailsFormState {
  static readonly type = '[PersonalDetailsForm] SetTaxesFormState';
  constructor(public payload: string) {}
}

export class SetEmploymentTypeId {
  static readonly type = '[PersonalDetailsForm] Set Employment Type Id';
  constructor(public payload: any) {}
}

export class SetUseEIN {
  static readonly type = '[PersonalDetailsForm] Set Use EIN';
  constructor(public payload: string) {}
}

export class SetFederalIdentifier {
  static readonly type = '[PersonalDetailsForm] Set Federal Identifier';
  constructor(public payload: string) {}
}

export class SetVerifyFederalIdentifier {
  static readonly type = '[PersonalDetailsForm] Set Verify Federal Identifier';
  constructor(public payload: string) {}
}

export class SetIsCompany {
  static readonly type = '[PersonalDetailsForm] Set Is Company';
  constructor(public payload: boolean) {}
}

export class SetFirstName {
  static readonly type = '[PersonalDetailsForm] Set First Name';
  constructor(public payload: string) {}
}

export class SetMiddleName {
  static readonly type = '[PersonalDetailsForm] Set Middle Name';
  constructor(public payload: string) {}
}

export class SetLastName {
  static readonly type = '[PersonalDetailsForm] Set Last Name';
  constructor(public payload: string) {}
}

export class SetBirthday {
  static readonly type = '[PersonalDetailsForm] Set Birthday';
  constructor(public payload: { year: number; month: number; day: number }) {}
}

export class SetPersonalEmailAddress {
  static readonly type = '[PersonalDetailsForm] Set Personal Email Address';
  constructor(public payload: string) {}
}

export class SetHomePhoneNumber {
  static readonly type = '[PersonalDetailsForm] Set Home Phone Number';
  constructor(public payload: string) {}
}

export class SetMobilePhoneNumber {
  static readonly type = '[PersonalDetailsForm] Set Mobile Phone Number';
  constructor(public payload: string) {}
}

export class SetGender {
  static readonly type = '[PersonalDetailsForm] Set Gender';
  constructor(public payload: string) {}
}

export class SetMaritalStatus {
  static readonly type = '[PersonalDetailsForm] Set Marital Status';
  constructor(public payload: number) {}
}

export class SetRace {
  static readonly type = '[PersonalDetailsForm] Set Race';

  constructor(public payload: number) {}
}

export class SetStreetAddress {
  static readonly type = '[PersonalDetailsForm] Set Street Address';
  constructor(public payload: string) {}
}

export class SetStreetAddress2 {
  static readonly type = '[PersonalDetailsForm] Set Street Address 2';
  constructor(public payload: string) {}
}

export class SetCity {
  static readonly type = '[PersonalDetailsForm] Set City';
  constructor(public payload: string) {}
}

export class SetState {
  static readonly type = '[PersonalDetailsForm] Set State';
  constructor(public payload: string) {}
}

export class SetPostalCode {
  static readonly type = '[PersonalDetailsForm] Set Postal Code';
  constructor(public payload: string) {}
}

export class SetCountry {
  static readonly type = '[PersonalDetailsForm] Set Country';
  constructor(public payload: string) {}
}

export class SetIsNonUSAddress {
  static readonly type = '[PersonalDetailsForm] Set Is Non US Address';
  constructor(public payload: boolean) {}
}
